import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SortOption from '../models/SortOption';

export const SORT_OPTION_TO_NAME_MAPPING = {
  [SortOption.DEFAULT]: 'Favourites first',
  [SortOption.PRICE_ASC]: 'Total price: Low to High',
  [SortOption.PRICE_DESC]: 'Total price: High to Low',
  [SortOption.PRICE_PER_ASC]: 'Price per: Low to High',
  [SortOption.PRICE_PER_DESC]: 'Price per: High to Low',
  [SortOption.NAME_ASC]: 'Product name: A-Z',
  [SortOption.NAME_DESC]: 'Product name: Z-A',
  [SortOption.SHELF_LIFE]: 'Life: Short to Long',
  [SortOption.CUSTOMER_RATING]: 'Customer rating',
};

const PRICE_PER_SORTING_BETA_FEATURE = 'PRICE_PER_SORTING'; // {M} turns off price per sort

export default class SortSelect extends Component {
  static propTypes = {
    sort: PropTypes.oneOf(Object.keys(SortOption)), // the currently selected sort option
    onSortChange: PropTypes.func,
    excludedSort: PropTypes.array,
    betaFeatures: PropTypes.array,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      query: PropTypes.object,
    }),
    router: PropTypes.object,
  };

  shouldComponentUpdate(nextProps) {
    return this.props.sort !== nextProps.sort
      || this.props.onSortChange !== nextProps.onSortChange;
  }

  /**
   * @param event {Event}
   */
  handleSortChange = (event) => {
    const sort = event.currentTarget.value;

    // allow the container to pass own handler method
    if (this.props.onSortChange) {
      this.props.onSortChange(sort);
    }
    this.sortSelect.blur();

    // allow the optional handler method can prevent the default behaviour
    if (!event.defaultPrevented) {
      this.props.router.push({
        pathname: this.props.location.pathname,
        query: { ...this.props.location.query, sort },
      });
    }
  };

  renderOptions() {
    const excludedSort = this.props.excludedSort || [];
    let sortOptionKeys = Object.keys(SortOption);
    if (this.props.betaFeatures && this.props.betaFeatures.indexOf(PRICE_PER_SORTING_BETA_FEATURE) < 0) {
      sortOptionKeys = sortOptionKeys.filter(option =>
        option !== SortOption.PRICE_PER_ASC && option !== SortOption.PRICE_PER_DESC
      );
    }
    sortOptionKeys = sortOptionKeys.filter(option => !excludedSort.includes(option));
    return sortOptionKeys.map(option => (
      <option
        key={option}
        value={option}
      >{SORT_OPTION_TO_NAME_MAPPING[option]}
      </option>
    ));
  }

  render() {
    const { sort = SortOption.DEFAULT } = this.props;

    return (
      <div className="sorting">
        <form className="sortBy">
          <span className="sort-wrapper">
            <select
              name="sortBy"
              onChange={this.handleSortChange}
              value={sort}
              ref={(ref) => { this.sortSelect = ref; }}
            >
              {this.renderOptions()}
            </select>
          </span>
        </form>
      </div>
    );
  }
}
